<template>
  <Row justify="start" type="flex" :gutter="10" style="padding-top: 3px">
    <Col span="8">
      <FormItem prop="country" style="margin-bottom: 0">
        <Select
          :disabled="disabled"
          @on-change="changeCountry"
          filterable
          placeholder="--国家--"
          v-model="content.country"
        >
          <Option
            :key="item.name"
            :value="item.name"
            v-for="item in countryList"
            >{{ item.name }}/{{ item.pinyin }}</Option
          >
        </Select>
      </FormItem>
    </Col>
    <Col span="8" v-if="content.country === '中国'">
      <FormItem prop="province" style="margin-bottom: 0">
        <Select
          :disabled="disabled"
          @on-change="changeProvince"
          placeholder="--省份/Province--"
          v-model="content.province"
        >
          <Option
            :key="'province-' + item.id"
            :value="item.name"
            v-for="item in provinceArr"
            >{{ item.name }}/{{ item.pinyin }}</Option
          >
        </Select>
      </FormItem>
    </Col>
    <Col span="8" v-if="content.country === '中国'">
      <FormItem prop="city" style="margin-bottom: 0">
        <Select
          :disabled="disabled"
          @on-change="changeCity"
          placeholder="--城市/City--"
          v-model="content.city"
        >
          <Option
            :key="'city-' + item.name"
            :value="item.name"
            v-for="item in citiesArr"
            >{{ item.name }}/{{ item.pinyin }}</Option
          >
        </Select>
      </FormItem>
    </Col>
    <!-- <Col span="6" v-if="countyArr.length && false">
    <FormItem prop="city" style="margin-bottom: 0;">
      <Select :disabled="disabled" @on-change="changeCounty" placeholder="请选择区县" v-model="content.county">
        <Option :key="'county-' + item.name" :value="item.name" v-for="(item) in countyArr">{{ item.name }}</Option>
      </Select>
    </FormItem>
    </Col> -->
  </Row>
</template>

<script>
import country from "@assets/js/country";
import { mapActions } from "vuex";

export default {
  name: "m-form-address",
  model: {
    prop: "content",
    event: "change",
  },
  props: {
    content: {
      type: Object,
      default: {
        country: "中国", // 国家
        province: "", // 省份
        city: "", // 城市
        county: "", // 区县
        details: "", // 详细
      },
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      countryList: "",
      provinceArr: [],
      citiesArr: [],
      countyArr: [],
    };
  },
  mounted() {
    this.getCountry();
  },
  methods: {
    ...mapActions({
      graphqlPost: "graphqlPost",
      getCountryNew: "getCountryNew",
    }),
    async getCountry() {
      let arr = await this.getCountryNew();
      this.countryList = arr;
      setTimeout(() => {
        if (this.content.country) {
          this.changeCountryInit(this.content.country);
        } else {
          this.changeCountryInit("中国");
        }
        if (this.content.province) {
          this.changeProvinceInit(this.content.province);
        }
        if (this.content.city) {
          this.changeCityInit(this.content.city);
        }
      }, 400);
    },
    async changeCountryInit(val) {
      let item = null;
      this.countryList.forEach((c) => {
        if (c.name === val) {
          item = c;
        }
      });
      if (!item) return;
      this.provinceArr = item.childrens || [];
    },
    async changeProvinceInit(val) {
      let item = null;
      this.provinceArr.childrens.forEach((c) => {
        if (c.name === val) {
          console.log(c, "c");
          item = c;
        }
      });
      if (!item) return;
      // this.citiesArr =
      //   item.childrens.length == 1
      //     ? item.childrens[0].childrens
      //     : item.childrens;
      this.citiesArr = item.childrens;
    },
    async changeCityInit(val) {
      let item = null;
      this.citiesArr.forEach((c) => {
        if (c.name === val) {
          item = c;
        }
      });
      if (!item) return;
      this.countyArr = item.childrens || [];
    },

    async changeCountry(val) {
      let item = null;
      this.countryList.forEach((c) => {
        if (c.name === val) {
          console.log(c.childrens, "c.childrens");
          item = c.childrens;
        }
      });
      if (!item) return;
      this.provinceArr = item;
      console.log(this.provinceArr, "item");
      this.citiesArr = [];
      this.countyArr = [];
      this.content.province = "";
      this.content.city = "";
      this.content.county = "";
      this.$emit("change", this.content);
    },
    async changeProvince(val) {
      console.log(val, "1111111");
      let item = null;
      this.provinceArr.forEach((c) => {
        if (c.name === val) {
          item = c;
        }
      });
      if (!item) return;
      this.citiesArr = item.childrens;
      this.countyArr = [];
      this.content.city = "";
      this.content.county = "";
      this.$emit("change", this.content);
    },
    async changeCity(val) {
      console.log(this.content, "222222");
      let item = null;
      this.citiesArr.forEach((c) => {
        if (c.name === val) {
          item = c;
        }
      });
      if (!item) return;
      this.countyArr = item.childrens || [];
      this.content.county = "";
      this.$emit("change", this.content);
    },
    async changeCounty() {
      this.$emit("change", this.content);
    },
  },
};
</script>

<style lang="scss" scoped>
</style>